<template>
    
    
    <div class="bodyFour">
      <div class="bodyFour_top">
        <div class="title">
          <h3>{{h3}}</h3>
          <p>{{p}}</p> 
        </div>
      </div>
      <div class="bodyFour_bottom">
        <div class="bodyFour_bottom_box">
          <div class="four_neirong">
            <img src="../assets/yh.png" alt="" />
            <h3>城市合伙人咨询电话</h3>
            <h4>400-891-6060</h4>
            <h3 class="two_h3">咨询时间</h3>
            <h5>周一至周五 08:30-17:30</h5>
            <img src="../assets/four_erweima.png" class="erweima" alt="" />
            <p>扫描二维码</p>
            <p>加入城市合伙人</p>
          </div>
        </div>

        <img src="../assets/index_fonr_bg.png" style="width: 100%" alt="" />
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return{

      }  
    },
    props:{
      h3:{
        type:String
      },
      p:{
        type:String
      }
    }
  }

</script>



<style lang="scss" scoped>
img{
    display: block;
}
.bodyFour {
  padding-top: 120px;
  .bodyFour_top {
    .title {
      padding-bottom: 180px;
      h3 {
        margin: 0;
        font-size: 32px;
        color: #333333;
        margin-bottom: 20px;
      }
      p {
        margin: 0;
        font-size: 20px;
        color: #969696;
        text-transform: uppercase;
      }
    }
  }
  .bodyFour_bottom {
    position: relative;

    .bodyFour_bottom_box {
      width: 1380px;
      position: absolute;
      left: 50%;
      margin-left: -680px;
      bottom: 0;
      .four_neirong {
        box-sizing: border-box;
        padding: 40px 50px 70px;
        width: 445px;
        background: #fff;
        text-align: left;
        border: 1px solid #eeeeee;
        .erweima{
          width: 200px;
        }
        h3 {
          font-size: 24px;
          color: #333333;
          margin: 0;
          margin-top: 33px;
        }
        h4 {
          margin: 0;
          margin-top: 27px;
          font-size: 26px;
          color: #333333;
          font-weight: 400;
        }
        .two_h3 {
          margin-top: 58px;
        }
        h5 {
          margin: 0;
          margin-top: 33px;
          font-size: 20px;
          color: #333333;
          font-weight: 400;
        }
        img {
          margin-top: 55px;
        }
        p {
          font-size: 20px;
          color: #333333;
          margin: 0;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>